// @ts-ignore
import * as common from './common'
import * as allIcons from './icons'

const icons = allIcons.default

export { common, icons }
